// import { cityStateLookup } from './city-state-look-up.js'
// import {
// 	setShippingValidationRules,
// 	setBillingValidationRules,
// } from '../checkout/setValidationRules.ts'
import isHidden from '../utils/isHidden.js'

export function validateAddress () {
  if ($('#verifyAddress').attr('data-verify') === 'yes') {
    // for Vietnam do not check zip code.
    if ($('#address1').val() !== '' && $('#city').val() !== '' && ($('#zip').val() !== '' || $('#countryId').val() === 237) && $('#stateId').val() !== '' && $('#countryId').val() !== '') {
      let input = $('#address1').val()
      if ($('#address2').val() !== '') {
        input = input + ' ' + $('#address2').val()
      }
      if ($('#city').val() !== '') {
        input = input + ', ' + $('#city').val()
      }
      let stateValule = $('#stateId option:selected').attr('brief')
      if (!stateValule) {
        stateValule = $('#stateId option:selected').text()
      }
      input = input + ', ' + stateValule
      if ($('#zip').val() !== '') {
        input = input + ' ' + $('#zip').val()
      }
      input = input + ', ' + $('#countryId option:selected').text()
      // console.log(stateValule);
      // console.log(input);
      // verify data by google map
      $.ajax({
        url: '/api/address/verify-address',

        // The data to send (will be converted to a query string)
        data: {
          address: input,
          address1: $('#address1').val().trim(),
          address2: $('#address2').val().trim(),
          city: $('#city').val().trim(),
          state: stateValule,
          zip: $('#zip').val().trim(),
          country: $('#countryId option:selected').text(),
					countryId: $('#countryId').val().trim()
        },

        // Whether this is a POST or GET request
        type: 'GET',

        // The type of data we expect back
        dataType: 'json'
      })
        // Code to run if the request succeeds (is done);
        // The response is passed to the function
        .done(json => {
          // console.log(json.data.suggested_address);
          if (json.status == 1) {
            if (json.match == false) {
							$('#enteredAddress1').text($('#address1').val())
              $('#enteredAddress2').text($('#address2').val())
              $('#enteredCity').text($('#city').val())
              $('#enteredState').text(stateValule)
              $('#enteredZipcode').text($('#zip').val())
              $('#enteredCountry').text($('#countryId option:selected').text())

              $('#suggestedAddress1').text(json.data.suggested_address.address1)
              $('#suggestedAddress2').text(json.data.suggested_address.address2)
              $('#suggestedCity').text(json.data.suggested_address.city)
              $('#suggestedState').text(json.data.suggested_address.state)
              $('#suggestedZipcode').text(json.data.suggested_address.zipcode)
              $('#suggestedCountry').text(json.data.suggested_address.country)

              if(isHidden(document.querySelector('#verifyAddress'))) {
                $('#verifyAddress')
                .on('show.bs.modal', () => {
                  $('#phone').blur()
                })
                .on('hidden.bs.modal', () => {
                  $('#phone').focus()
                })
                .modal({
                  show: true
                })
              }
            } else if ($('#validateSuccessMsg').length > 0) {
              $('#validateSuccessMsg').show()
              setTimeout(function () {
								$('#validateSuccessMsg').hide()
							}, 3000)
            }
          } else if (json.status == 2 && $('#select-mid-delivery :selected').attr('data-delivery-type') != 'eticket') {
            $('#unVerifiedAddress1').text($('#address1').val())
            $('#unVerifiedAddress2').text($('#address2').val())
            $('#unVerifiedCity').text($('#city').val())
            $('#unVerifiedState').text($('#stateId option:selected').text())
            $('#unVerifiedZipcode').text($('#zip').val())
            $('#unVerifiedCountry').text($('#countryId option:selected').text())
            $('#unVerifiedMessages').html(json.messages)

						if(isHidden(document.querySelector('#verifyAddress'))) {
							$('#unVerifiedAddress')
              .on('show.bs.modal', () => {
                $('#phone').blur()
              })
              .on('hidden.bs.modal', () => {
                $('#phone').focus()
              })
              .modal({
                show: true
              })
						}
          }
        })
    }
  }
}

export function validateAddressActions () {
  let validAddress = false

  $('#addressForm').on('change', '#address1, #address2, #countryId, #zip, #stateId, #city', function () {
		validAddress = false
	})

  $('#addressForm').on('blur', '#phone, #city', function (event) {
		if (validAddress == false) {
			validAddress = true
			validateAddress()
		}

		// setShippingValidationRules()
	})

  // $('#zip, #countryId').change(() => {
  //   const zipVal = $('#zip').val().trim()
  //   const countryVal = $('#countryId option:selected').text()
  //   cityStateLookup(zipVal,countryVal,'city','stateId', setShippingValidationRules)
  //   if ($("#cityBilling").length > 0 && $("#zipBilling").length > 0) {
  //     if ($('#cityBilling').val().trim() === '' && $('#zipBilling').val().trim() === '') {
  //       cityStateLookup(
  //         zipVal,
  //         countryVal,
  //         'cityBilling',
  //         'stateIdBilling',
  //         setBillingValidationRules,
  //       )
  //     }
  //   }
  // })

  // $('#zipBilling, #countryIdBilling').change(() => {
  //   cityStateLookup(
	// 		$('#zipBilling').val().trim(),
	// 		$('#countryIdBilling option:selected').text(),
	// 		'cityBilling',
	// 		'stateIdBilling',
	// 		setBillingValidationRules,
	// 	)
  // })

  $('.selectValidAddress').click(function (event) {
    event.preventDefault()
    if (this.id == 'useSuggestedAddress') {
      $('#address1').val($('#suggestedAddress1').text())
      $('#address2').val($('#suggestedAddress2').text())
      $('#city').val($('#suggestedCity').text())
      $('#stateId > option').each(function () {
        if ($(this).attr('brief') == $('#suggestedState').text()) {
          $('#stateId').val(this.value)
        } else if (this.text == $('#suggestedState').text()) {
          $('#stateId').val(this.value)
        }
      })
      $('#zip').val($('#suggestedZipcode').text())
      $('#countryId > option').each(function () {
        if (this.text == $('#suggestedCountry').text()) {
          $('#countryId').val(this.value)
        }
      })
    }
    // $.fancybox.close(true)
  })
}

window.validateAddress = validateAddress
window.validateAddressActions = validateAddressActions
